/**
 *
 * clip actions
 *
 */

import {
    LOAD_PLAYBACK_PAGE
} from './playback-page-constants';

/**
 * Load the page data, this action starts the bootstrap saga
 *
 * @param  {string} contentId  The clip unique identifier
 * @param  {string} topicId  The topic unique identifier
 *
 * @return {object}     An action object with a type of LOAD_CLIP
 */
export const getPageData = (contentId, topicId = '') => ({
    type: LOAD_PLAYBACK_PAGE,
    contentId,
    topicId,
});
